import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReusableAlertPopupComponent } from "./reusable-alert-popup.component";

@NgModule({
  declarations: [ReusableAlertPopupComponent],
  imports: [CommonModule],
  exports: [ReusableAlertPopupComponent],
})
export class ReusableAlertPopupModule {}
